import * as React from 'react';

import { Tooltip } from '@dndbeyond/character-common-components/es';
import { CharacterTheme } from '@dndbeyond/character-rules-engine/es';

import { DarkAttunementSvg, GrayAttunementSvg } from '../../Svg';

interface SvgInjectedProps {
    className?: string;
}
interface Props {
    className?: string;
    showTooltip?: boolean;
    theme?: CharacterTheme;
}
const AttunementIcon: React.FunctionComponent<Props> = ({ className = '', showTooltip = true, theme }) => {
    let classNames: Array<string> = [className, 'ddbc-attunement-icon'];

    let SvgIcon: React.ComponentType<SvgInjectedProps> = theme?.isDarkMode ? GrayAttunementSvg : DarkAttunementSvg;

    return (
        <span className={classNames.join(' ')}>
            <Tooltip title={'Item is Attuned'} enabled={showTooltip} isDarkMode={theme?.isDarkMode}>
                <SvgIcon className="ddbc-attunement-icon__icon" />
            </Tooltip>
        </span>
    );
};

export default AttunementIcon;
